import { put, takeLatest } from 'redux-saga/effects'

import { searchCompanies } from '../../core/apiModules/companies'
import * as blockedCompaniesModule from '../reducks/blockedCompanies'
import * as blockedCompaniesApi from '../apiModules/blockedCompanies'

function* createBlockedCompanySaga({ payload }) {
  try {
    const response = yield blockedCompaniesApi.createBlockedCompany(payload.id, payload.data)
    yield put(blockedCompaniesModule.fetchBlockedCompanies(payload.id))

    if (response.hasOwnProperty('blocked_linked_companies')) {
      yield put(blockedCompaniesModule.addLinkedCompanies(response))
      yield put(
        blockedCompaniesModule.showMessage(
          `We see you added ‘${response.name}’, we have included their sister companies for you to also block. Click to remove if you’re happy for those companies to see your profile`,
        ),
      )
    }
  } catch (error) {
    yield put(
      blockedCompaniesModule.throwError(
        'There was an error blocking this company. Please try again or contact your Talent Advisor for further assistance.',
      ),
    )
  }
}

function* fetchBlockedCompaniesSaga(action) {
  try {
    const response = yield blockedCompaniesApi.fetchBlockedCompanies(action.payload.id)
    yield put(blockedCompaniesModule.fetchBlockedCompaniesSuccess(response))
  } catch (error) {}
}

function* deleteBlockedCompaniesSaga(action) {
  try {
    yield blockedCompaniesApi.deleteBlockedCompany(action.payload.id)
    yield put(blockedCompaniesModule.fetchBlockedCompanies(action.payload.candidate_id))
    yield put(blockedCompaniesModule.clearError())
    yield put(blockedCompaniesModule.clearMessage())
  } catch (error) {
    yield put(
      blockedCompaniesModule.throwError(
        'An error occurred while removing this blocked company. Please try again or contact your Talent Advisor for further assistance.',
      ),
    )
  }
}

function* searchCompaniesSaga({ meta, payload }) {
  try {
    const response = yield searchCompanies(meta.term)

    yield put(blockedCompaniesModule.searchCompaniesSuccess(response))
  } catch (error) {
    yield put(blockedCompaniesModule.searchCompaniesError(error))
  }
}

export default function* watchBlockedCompaniesSaga() {
  yield takeLatest(blockedCompaniesModule.CREATE, createBlockedCompanySaga)
  yield takeLatest(blockedCompaniesModule.FETCH, fetchBlockedCompaniesSaga)
  yield takeLatest(blockedCompaniesModule.DELETE, deleteBlockedCompaniesSaga)
  yield takeLatest(blockedCompaniesModule.SEARCH_COMPANIES, searchCompaniesSaga)
}
